module.exports = __webpack_public_path__ + "img/bt.e812a145.png";